/* eslint-disable */
import { CalendarIcon, Pen } from 'lucide-react'
import { Button } from '../../Components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { addNumberSuffix, monthShortNames } from '../../utils/Util'
import { isDematUser } from '../../utils/AuthUtil'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'

const ActionPlanBottomBar = ({
  flowStep,
  sipDate,
  sipDates,
  selectedDay,
  setSelectedDay,
  disableButtons,
  generateOTP,
  loading,
  setMessageModalState,
  openOTPPopup,
  setOpenOTPPopup,
  userDetails,
  email,
  handleSipOrOT,
}) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 p-4 z-10 lg:max-w-[1128px] mx-auto bg-white mt-2`}
      style={{ boxShadow: '0px 4px 21.6px 0px #00000040', borderRadius: '24px 24px 0px 0px' }}
    >
      <div className='mx-auto space-y-2'>
        {flowStep === 0 && (
          <div className='mt-4'>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant={'outline'}
                  className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                >
                  <span className='text-primary-500 flex items-center gap-x-2'>
                    <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                    <p>
                      SIP starts on -{' '}
                      <b>
                        {addNumberSuffix(sipDate.split('/')[0])}{' '}
                        {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                        {sipDate.split('/')[2]}
                      </b>
                    </p>
                  </span>

                  <Pen className='h-4 w-4 text-primary-500' />
                </Button>
              </PopoverTrigger>
              <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                <div className='flex gap-x-2 p-2'>
                  {sipDates.map((day, index) => (
                    <Button
                      key={(day + index).toString()}
                      className={`h-8 w-8 rounded-full inline-block ${selectedDay !== +day
                        ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                        : 'text-white'
                        }`}
                      size='simple'
                      onClick={() => setSelectedDay(+day)}
                    >
                      {day}
                    </Button>
                  ))}
                </div>
              </PopoverContent>
            </Popover>
          </div>
        )}

        {isDematUser() ? (
          <Button
            disabled={disableButtons <= 0}
            className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-300`}
            onClick={generateOTP}
            loading={loading}
          >
            Continue
          </Button>
        ) : (
          <Button
            disabled={disableButtons <= 0}
            className={`w-full rounded-xl bg-primary-500 disabled:bg-primary-300`}
            onClick={() =>
              setMessageModalState({
                message: 'Your KYC is incomplete.',
                linkMessage:
                  'Click here to complete your KYC and to enable hassle free, one-click investing.',
                severity: 'info',
              })
            }
          >
            Complete your KYC
          </Button>
        )}

        {flowStep === 0 && (
          <p className='text-xs mt-2 text-center font-semibold'>
            Keep your internet banking password ready for quick setup.
          </p>
        )}

        {openOTPPopup && (
          <OrderOtpVerification
            phoneNumber={userDetails?.phoneNumber}
            openOTPPopup={openOTPPopup}
            setOpenOTPPopup={setOpenOTPPopup}
            email={email}
            handleSipOrOT={handleSipOrOT}
          />
        )}
      </div>
    </div>
  )
}

export default ActionPlanBottomBar
